import { gql } from '@apollo/client'

export const GET_API_CLIENT_ACCESSES = gql`
  query GetApiClientAccesses(
    $filter: ApiClientAccessFilter
    $sort: ApiClientAccessSort
    $page: Int
    $pageSize: Int
  ) {
    apiClientAccesses(
      filter: $filter
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      items {
        apiClientAccessId
        clientId
        clientName
        clientStatus
        auth0Url
        logsUrl
        company {
          companyId
          companyName
        }
        scopes
        active
        lastSeenAt
        createdAt
        updatedAt
        lastEditedBy {
          userId
          firstName
          lastName
        }
      }
      total
      auth0ApplicationsUrl
    }
  }
`

export const GET_ADMIN_COMPANIES = gql`
  query GetAdminCompanies($search: String) {
    adminCompanies(search: $search) {
      companyId
      companyName
    }
  }
`

export const CREATE_API_CLIENT_ACCESS = gql`
  mutation CreateApiClientAccess($input: CreateApiClientAccessInput!) {
    createApiClientAccess(input: $input) {
      apiClientAccessId
      clientId
      clientName
      company {
        companyName
      }
    }
  }
`

export const UPDATE_API_CLIENT_ACCESS = gql`
  mutation UpdateApiClientAccess(
    $apiClientAccessId: String!
    $input: UpdateApiClientAccessInput!
  ) {
    updateApiClientAccess(
      apiClientAccessId: $apiClientAccessId
      input: $input
    ) {
      apiClientAccessId
      scopes
      active
    }
  }
`

export const DELETE_API_CLIENT_ACCESS = gql`
  mutation DeleteApiClientAccess($apiClientAccessId: String!) {
    deleteApiClientAccess(apiClientAccessId: $apiClientAccessId) {
      apiClientAccessId
    }
  }
`

export const GET_API_CLIENT_ACCESS_HISTORY = gql`
  query GetApiClientAccessHistory($clientId: String!, $companyId: String!) {
    apiClientAccessHistory(clientId: $clientId, companyId: $companyId) {
      auditTrailId
      createdAt
      changeType
      user {
        userId
        firstName
        lastName
      }
      prevScopes
      newScopes
      prevActive
      newActive
    }
  }
`
